import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { Observable } from 'rxjs';
import { IMeasureUnit } from '../../../../models/measure-unit.model';
import { MeasureUnitFacade } from '../../../../services/facades/master-data/measure-unit.facade';
import { IMeasureUnitState } from '../../../../services/facades/master-data/measure-unit.state.model';

@Component({
    selector: 'app-measure-unit-dialog',
    templateUrl: './measure-unit-dialog.component.html',
    styleUrls: [ './measure-unit-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasureUnitDialogComponent implements OnInit, AfterViewInit {
    public measureUnitState$: Observable<IMeasureUnitState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;


    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IMeasureUnit,
        private myMatDialogRef: MatDialogRef<MeasureUnitDialogComponent>,
        private myMeasureUnitFacade: MeasureUnitFacade,
    ) {
    }

    public ngOnInit(): void {
        this.measureUnitState$ = this.myMeasureUnitFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((measureUnit: IMeasureUnit) => {
            this.validateDialogFields(measureUnit);
        });
    }

    public async save(): Promise<void> {
        const data = this.formGroup.value as IMeasureUnit;
        data.erpMeasureNr = !isNullOrUndefined(data.erpMeasureNr) && data.erpMeasureNr.trim() === '' ? undefined : data.erpMeasureNr;
        if (isNullOrUndefined(this.data.id)) {
            await this.myMeasureUnitFacade.addMeasureUnit(data);
        } else {
            data.id = this.data.id;
            await this.myMeasureUnitFacade.updateMeasureUnit(data);
        }
        this.myMatDialogRef.close(true);
    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(measureUnit: IMeasureUnit): void {
        // Validations to disable saving/editing
        if (!measureUnit.name) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
